import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const TrainingCreateForm = React.lazy(() => loadComponent('traiwiss', 'TrainingCreateForm'))

export function TrainingCreateRoute() {
    const navigate = useNavigate()
    const { academy } = useFlightDeck()

    const onCreate = useCallback(() => {
        navigate('/trainings/')
    }, [navigate])

    const onClose = useCallback(() => {
        navigate('/trainings')
    }, [navigate])

    return (
        <RouteContainer>
            <TrainingCreateForm academyId={academy?._id} onCreated={onCreate} onClosed={onClose} />
        </RouteContainer>
    )
}
